import React, { useImperativeHandle, useRef } from 'react'
import { DragSource, DropTarget } from 'react-dnd'

const Card = React.forwardRef(
    ({ text, isDragging, connectDragSource, connectDropTarget, props }, ref) => {
        const elementRef = useRef(null)
        connectDragSource(elementRef)
        connectDropTarget(elementRef)
        const opacity = isDragging ? 0 : 1
        useImperativeHandle(ref, () => ({
            getNode: () => elementRef.current,
        }))
        return (
            <div ref={elementRef} style={{ opacity }} className="muchWayPoint">
                <span className="iconsNavi"></span>
                {/* <button className="btnsNavi btnAdd" title="추가" style={{display:'none'}}>추가</button> */}
                <span className="txt1">{text}</span>
                <button className="btnsNavi btnDel" title="삭제" onClick={() => {props.deleteCard(props.wayPoint)}}>삭제</button>
            </div>
        )
    },
)

export default DropTarget(
    'card',
    {
      hover(props, monitor, component) {
        // if (!component) {
        //   return null
        // }
        // const node = component.getNode()
        // if (!node) {
        //   return null
        // }
        const dragIndex = monitor.getItem().index
        const hoverIndex = props.index
        console.log(dragIndex + ' : ' + hoverIndex)
        if (dragIndex === hoverIndex) {
          return
        }

        // const hoverBoundingRect = node.getBoundingClientRect()
        // const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
        // const clientOffset = monitor.getClientOffset()
        // const hoverClientY = clientOffset.y - hoverBoundingRect.top

        // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        //   return
        // }

        // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        //   return
        // }

        props.moveCard(dragIndex, hoverIndex)
        monitor.getItem().index = hoverIndex
      },
    },
    connect => ({
      connectDropTarget: connect.dropTarget(),
    }),
  )(
    DragSource(
      'card',
      {
        beginDrag: props => ({
          id: props.id,
          index: props.index,
        }),
      },
      (connect, monitor, props) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
        props: props
      }),
    )(Card),
  )